<template>
    <section id="content">
        <loader v-if="loader == true"></loader>
        <div class="page page-hz-menu-layout">
            <div class="row form-group">
                <div class="col-md-2">
                    <ul class="tabs-menu">
                        <li :class="(tab == 1) ? 'active' : ''" @click="tab = 1"><a href="javascript:void(0)">1.
                                Simulação</a></li>
                        <li :class="(tab == 2) ? 'active' : ''" @click="tab = 2"><a href="javascript:void(0)">2.
                                Anexos</a></li>
                    </ul>
                    <br>
                    <div class="alert alert-success" v-if="proposta.aprovacao_automatica == true">
                        <strong><i class="fa fa-check"></i></strong>
                        Simulação Aprovada.
                    </div>
                    <div class="alert alert-warning" v-if="proposta.aprovacao_automatica == false">
                        <strong><i class="fa fa-warning"></i></strong>
                        Simulação Pendente de Aprovação.
                    </div>
                </div>
                <div class="col-md-10">
                    <section class="tile" v-if="tab == 1">
                        <div class="tile-header dvd dvd-btm">
                            <h1 class="custom-font"><strong>Dados</strong> Simulação #{{ proposta.id }}</h1>
                            <ul class="controls">
                            </ul>
                        </div>
                        <div class="tile-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <fieldset class="scheduler-border">
                                        <legend class="scheduler-border">Operação</legend>
                                        <label>Tipo</label>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <select name="tipo_proposta_id" id="tipo_proposta_id"
                                                    class="form-control" v-model="proposta.tipo_proposta_id" required
                                                    disabled>
                                                    <option value="1">Automóvel</option>
                                                    <option value="2">Motocicleta</option>
                                                </select>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="col-md-10">
                                    <fieldset class="scheduler-border">
                                        <legend class="scheduler-border">Veículo</legend>
                                        <div class="row form-group">
                                            <div class="col-md-3">
                                                <label for="marcas">Marca</label>
                                                <div class="input-group">
                                                    <span class="input-group-btn">
                                                        <button class="btn btn-success"
                                                            v-if="editarVeiculo == false && proposta.simulacao == true"
                                                            data-toggle="tooltip" data-placement="bottom"
                                                            @click="alterarVeiculo()" title="Editar Veículo">
                                                            <i class="fa fa-edit"></i>
                                                        </button>
                                                    </span>
                                                    <input :type="editarVeiculo == true ? 'hidden' : 'text'" disabled
                                                        name="marca" id="marca_v" v-model="objeto.marca"
                                                        class="form-control">
                                                </div>
                                                <input type="hidden" name="id_fipe" id="fipe_codigo"
                                                    v-model="objeto.fipe_id" class="form-control">
                                                <div class="input-group">
                                                    <span class="input-group-btn">
                                                        <button class="btn btn-danger"
                                                            v-if="editarVeiculo == true && proposta.simulacao == true"
                                                            data-toggle="tooltip" data-placement="bottom"
                                                            @click="alterarVeiculo()"
                                                            title="Cancelar Edição de Veículo">
                                                            <i class="fa fa-times"></i>
                                                        </button>
                                                    </span>
                                                    <select v-if="editarVeiculo == true" name="marcas"
                                                        v-model="veiculo.marca" id="marcas" class="form-control"
                                                        required :disabled="proposta.simulacao == false"
                                                        @change="getModelos()">
                                                        <option v-for="m in marcas" :value="m.Value"> {{ m.Label }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <label for="veiculo">Veículo</label>
                                                <input :type="editarVeiculo == true ? 'hidden' : 'text'" name="modelo"
                                                    id="veiculo_modelo" disabled v-model="objeto.modelo"
                                                    class="form-control">
                                                <select v-if="editarVeiculo == true" id="veiculo"
                                                    v-model="veiculo.modelo" class="form-control"
                                                    :disabled="veiculo.marca == '' || !veiculo.marca" required
                                                    @change="getAnosModelo()">
                                                    <option v-for="m in modelos" :value="m.Value"> {{ m.Label }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-2">
                                                <label for="modelo">Ano</label>
                                                <input :type="editarVeiculo == true ? 'hidden' : 'text'" name="ano"
                                                    id="ano_v" disabled v-model="objeto.ano_modelo"
                                                    class="form-control">
                                                <select v-if="editarVeiculo == true" id="modelo"
                                                    v-model="veiculo.ano_modelo" class="form-control"
                                                    :disabled="veiculo.marca == '' || !veiculo.marca"
                                                    @change="getVeiculo()" required>
                                                    <option v-for="m in anoModelo" :value="m.Value"> {{ m.Label }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-2">
                                                <label>Valor Fipe <small>R$</small></label>
                                                <input :type="editarVeiculo == true ? 'hidden' : 'text'"
                                                    name="valor_fipe" :value="$utils.numberToReal(objeto.valor)"
                                                    disabled class="form-control currency" placeholder="0,00">
                                                <input v-if="editarVeiculo == true" type="text" v-money="money"
                                                    name="valor_fipe" id="valor_fipe" readonly :value="veiculo.valor"
                                                    class="form-control">
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <fieldset class="scheduler-border">
                                                <legend class="scheduler-border">Simulação</legend>
                                                <div class="row form-group">
                                                    <div class="col-md-6">
                                                        <label>Valor a Contratar <small>R$</small></label>
                                                        <input type="text" v-money="money" name="valor" id="valor"
                                                            :value="proposta.valor_proposta" class="form-control"
                                                            @blur="calcularParcelas()">
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label>Valor de Entrada <small>R$</small></label>
                                                        <input type="text" class="form-control" name="entrada"
                                                            :value="calcEntrada(proposta.valor_proposta, objeto.valor)"
                                                            style="color: rgb(120, 184, 0)!important;" disabled>
                                                    </div>
                                                </div>
                                                <div class="row form-group"
                                                    v-if="proposta.aprovacao_automatica == false">
                                                    <div class="col-md-6">
                                                        <label>R$ Valor Aprovado</label>
                                                        <input type="text" v-money="money" name="valor_aprovado"
                                                            id="valor_aprovado"
                                                            v-model="proposta.valor_aprovado_criterios" disabled
                                                            class="form-control">
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                    <div class="col-md-6">
                                                        <label>N°. Parcelas</label>
                                                        <input type="number" class="form-control" name="paarcelas"
                                                            id="parcelas" min="1" max="60" @blur="verificaParcelas()"
                                                            required v-model="proposta.parcelas">
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label>Dia 1° Parcela</label>
                                                        <datepicker :language="languages.ptBR" v-bind:format="format"
                                                            input-class="form-control data-parcela"
                                                            name="data_primeira_parcela" id="data_primeira_parcela"
                                                            :disabledDates="disabledDates" placeholder="DD/MM/AAAA"
                                                            required="required"
                                                            v-model="proposta.data_primeira_parcela">
                                                        </datepicker>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label>Valor Aproximado Parcela <small>R$</small></label>
                                                        <input type="text" v-money="money" name="valor_par"
                                                            id="valor_par" disabled class="form-control">
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(seguro == true && proposta.categoria_id == 1) ? 'col-md-5' : 'col-md-8'">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <fieldset class="scheduler-border">
                                                <legend class="scheduler-border">Proponente</legend>
                                                <div class="row">
                                                    <div class="col-md-4 form-group">
                                                        <label>CPF</label>
                                                        <input type="text" v-mask="['###.###.###-##']"
                                                            class="form-control" placeholder="000.000.000-00" name="cpf"
                                                            id="cpf" :disabled="!veiculo.ano || veiculo.ano == ''"
                                                            v-model="proponente.cpfcnpj" required>
                                                    </div>
                                                    <div class="col-md-8 form-group">
                                                        <label>Nome</label>
                                                        <input type="text" name="nome" id="nome" class="form-control"
                                                            v-model="proponente.nome" disabled
                                                            placeholder="NOME DO PROPONENTE">
                                                    </div>
                                                    <div class="col-md-6 form-group">
                                                        <label for="tipo_renda">Tipo Renda</label>
                                                        <select name="tipo_renda" id="tipo_renda" class="form-control"
                                                            required disabled v-model="proponente.tipo_renda">
                                                            <option value="9"> AGROPECUÁRIA</option>
                                                            <option value="3"> APOSENTADORIA</option>
                                                            <option value="1"> PRO-LABORE</option>
                                                            <option value="0"> SALÁRIO</option>
                                                            <option value="8"> RENDIMENTO NÃO COMPROVADO</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-6 form-group">
                                                        <label>PA</label>
                                                        <select name="pa_id" id="pa_id" v-model="proponente.pa_id"
                                                            class="form-control"
                                                            :disabled="proponente.cooperado == true" required>
                                                            <option v-for="p in pas" :value="p.cod_ponto_atendimento"
                                                                v-if="p.ordenacao != 97">{{ p.nome_ponto_atendimento }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6 form-group">
                                                        <label>Celular</label>
                                                        <input type="text" class="form-control"
                                                            placeholder="(99) 9 9999 9999" v-mask="['(##) # #### ####']"
                                                            name="celular" id="celular" v-model="proponente.celular"
                                                            required>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6"><br>
                                                        <label class="checkbox checkbox-custom-alt">
                                                            <input type="checkbox"
                                                                :checked="proponente.cooperado == true" disabled><i></i>
                                                            Cooperado Sicoob Crediauc
                                                        </label>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div class="row" v-if="proposta.aprovacao_automatica == false">
                                        <div class="col-md-12">
                                            <fieldset class="scheduler-border">
                                                <legend class="scheduler-border">Avalista</legend>
                                                <div class="row form-group">
                                                    <div class="col-md-4">
                                                        <label>CPF <small><b>*opcional</b></small></label>
                                                        <input type="text" v-mask="['###.###.###-##']"
                                                            class="form-control" placeholder="000.000.000-00"
                                                            name="cpfAval" id="cpfAval" v-model="avalista[0].cpfcnpj"
                                                            @change="validaCPF(0)" required>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label>Nome <small><b>*opcional</b></small></label>
                                                        <input type="text" name="nomeAval" id="nomeAval"
                                                            class="form-control" v-model="avalista[0].nome"
                                                            :disabled="avalista[0].cpfcnpj == ''"
                                                            placeholder="NOME DO AVALISTA">
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                    <div class="col-md-3">
                                                        <label>CPF <small><b>*opcional</b></small></label>
                                                        <input type="text" v-mask="['###.###.###-##']"
                                                            class="form-control" placeholder="000.000.000-00"
                                                            name="cpfAval2" id="cpfAval2" v-model="avalista[1].cpfcnpj"
                                                            @change="validaCPF(1)" required>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label>Nome <small><b>*opcional</b></small></label>
                                                        <input type="text" name="nomeAval2" id="nomeAval2"
                                                            class="form-control" v-model="avalista[1].nome"
                                                            :disabled="avalista[1].cpfcnpj == ''"
                                                            placeholder="NOME DO AVALISTA">
                                                        <br><br>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div v-if="seguro == true && proposta.categoria_id == 1" class="col-md-3"> -->
                                <!-- <div class="row">
                                  <div class="col-md-12">
                                    <fieldset class="scheduler-border" >
                                      <legend class="scheduler-border">Benefícios</legend>
                                      <div class="row form-group">
                                        <div class="col-md-12">
                                          <p style="font-size: 17px;">
                                            <label class="checkbox checkbox-custom-alt">
                                              <input type="checkbox" id="checkSeguro" name="checkSeguro"  :checked="proposta.seguro" disabled><i></i>
                                              <strong>Seguro terceiro</strong>
                                            </label>
                                          </p>
                                          <p><strong>Coberturas:</strong></p>
                                          <div id="listaBeneficios">
                                            <p><i class="text-greensea fa fa-check-circle"></i> Danos materiais a terceiro: <strong>R$ 100.000,00</strong></p>
                                            <p><i class="text-greensea fa fa-check-circle"></i> Danos corporais a terceiro: <strong>R$ 100.000,00</strong></p>
                                            <p><i class="text-greensea fa fa-check-circle"></i> Danos morais: <strong>R$ 10.000,00</strong></p>
                                            <p><i class="text-greensea fa fa-check-circle"></i> Assistência 24 horas (Guincho) - *300KM em caso de sinistro e *200KM em caso de pane</p>
                                            <p><i class="text-greensea fa fa-check-circle"></i> <strong>Válido por 1 ano</strong></p>
                                          </div>
                                        </div>
                                      </div>
                                    </fieldset>
                                  </div>
                                </div> -->
                                <div class="row" v-if="proposta.aprovacao_automatica == false">
                                    <div class="col-md-12">
                                        <fieldset class="scheduler-border">
                                            <legend class="scheduler-border">Avalista</legend>
                                            <div class="row form-group">
                                                <div class="col-md-3">
                                                    <label>CPF <small><b>*opcional</b></small></label>
                                                    <input type="text" v-mask="['###.###.###-##']" class="form-control"
                                                        placeholder="000.000.000-00" name="cpfAval" id="cpfAval"
                                                        v-model="avalista[0].cpfcnpj" @change="validaCPF(0)" required>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Nome <small><b>*opcional</b></small></label>
                                                    <input type="text" name="nomeAval" id="nomeAval"
                                                        class="form-control" v-model="avalista[0].nome"
                                                        :disabled="avalista[0].cpfcnpj == ''"
                                                        placeholder="NOME DO AVALISTA">
                                                </div>
                                            </div>
                                            <div class="row form-group">
                                                <div class="col-md-3">
                                                    <label>CPF <small><b>*opcional</b></small></label>
                                                    <input type="text" v-mask="['###.###.###-##']" class="form-control"
                                                        placeholder="000.000.000-00" name="cpfAval2" id="cpfAval2"
                                                        v-model="avalista[1].cpfcnpj" @change="validaCPF(1)" required>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Nome <small><b>*opcional</b></small></label>
                                                    <input type="text" name="nomeAval2" id="nomeAval2"
                                                        class="form-control" v-model="avalista[1].nome"
                                                        :disabled="avalista[1].cpfcnpj == ''"
                                                        placeholder="NOME DO AVALISTA">
                                                    <br><br>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <!-- </div> -->
                            </div>

                            <div class="row" align="center">
                                <div class="col-md-12">
                                    <router-link :to="{ name: 'IndexPropostas' }"
                                        class="btn btn-default btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10  btn-lg"
                                        style=" padding-top: 6px !important;"> Cancelar</router-link>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="tile" v-if="tab == 2">
                        <div class="tile-header dvd dvd-btm">
                            <h1 class="custom-font"><strong>Anexos</strong> Simulação #{{ proposta.id }}</h1>
                        </div>
                        <div class="tile-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <fieldset class="scheduler-border">
                                        <legend class="scheduler-border">Lista de Anexos</legend>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <p v-if="anexos.length == 0" align="center"><br><br>Não existem anexos
                                                    para está simulação.</p>
                                                <table class="table table-hover table-striped" v-if="anexos.length > 0">
                                                    <thead>
                                                        <tr>
                                                            <th>Nome</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="a in anexos">
                                                            <td>{{ a.nome_anexo }}</td>
                                                            <td style="text-align: right">
                                                                <a :href="'http://portalsicoobcrediauc.com/backend-auto/uploads/anexos/' + a.proposta_id + '/' + a.arquivo"
                                                                    class="btn btn-primary btn-xs" download="download"
                                                                    data-toggle="tooltip" data-placement="top"
                                                                    title="Baixar Anexo">
                                                                    <i class="fa fa-download"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
.activeSeguro {
    text-decoration: line-through;
    color: red;
}
</style>
<script>
import HeaderPropostas from './_header.vue';
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import Datepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/src/locale";
var moment = require('moment');

export default {
    name: 'editar-propostas',

    directives: {
        mask,
        money: VMoney
    },

    data() {
        return {
            editarVeiculo: false,
            anoBase: moment().format('YYYY') - 15,
            dataLimite: this.getDiasLimite(),
            dataAtual: moment().format("YYYY-MM-DD"),
            anoAtual : moment().format("yyyy"),
            disabledDates: {},
            language: "pt-br",
            languages: lang,
            format: 'dd/MM/yyyy',
            seguro: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' ',
                precision: 2,
                masked: true
            },
            moneyParcelas: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: ' ',
                precision: 2,
                masked: true
            },
            loader: true,
            tab: 1,
            avalista: [
                {
                    nome: '',
                    cpfcnpj: ''
                }, {
                    nome: '',
                    cpfcnpj: ''
                }
            ],
            proponente: {},
            proposta: {},
            objeto: {},
            anexo: {},
            pas: [],
            marcas: [],
            veiculo: {},
            parcelas: [],
            modelos: [],
            anexos: [],
            anoModelo: [],
            entrada: ''
        }
    },

    components: {
        'header-propostas': HeaderPropostas,
        Datepicker
    },

    methods: {


        verificaParcelas: function () {
            let anos =  (this.anoAtual - this.veiculo.ano.substring(0, 4));

            if (this.proposta.parcelas > 60) {
                $("#parcelas").val(60);
                this.proposta.parcelas = 60;
                return this.$toastr(
                    "warning",
                    "Número máximo de quantidade de parcelas deve ser de 1 a 60.",
                    "Atenção!"
                );
            }

            if (anos >= 11 && this.proposta.parcelas > 48)  {
                $("#parcelas").val(48);
                this.proposta.parcelas = 48;
                return this.$toastr(
                    "warning",
                    "Número máximo de parcelas para veículos de 11 a 15 anos (48x)",
                    "Atenção!"
                );
            }

            if (this.proposta.parcelas < 1) {
                $("#parcelas").val(1);
                this.proposta.parcelas = 1;
                return this.$toastr(
                    "warning",
                    "Número máximo de quantidade de parcelas deve ser de 1 a 60.",
                    "Atenção!"
                );
            }

            this.aprovacaoParcelas();
        },
        getDiasLimite: function () {
            var data = moment().format("YYYY-MM-DD");
            var dataIni = moment("2022-12-01").format("YYYY-MM-DD");
            var dataFin = moment("2022-12-31").format("YYYY-MM-DD");
            if (data >= dataIni && data <= dataFin) {
                return moment(moment().add(121, 'days').calendar(), 'MM-DD-YYYY').format('YYYY-MM-DD');
            }
            return moment(moment().add(61, 'days').calendar(), 'MM-DD-YYYY').format('YYYY-MM-DD');
        },
        calcularParcelas: function () {
            var $this = this;
            $this.loader = true;

            $this.$http.post('/propostas/simular/parcela', {
                ano_modelo: $this.objeto.ano_modelo,
                tipo_proposta_id: $this.proposta.tipo_proposta_id,
                parcelas: $this.proposta.parcelas,
                id: $this.proposta.id,
                created_at: $this.proposta.created_at,
                data_primeira_parcela: $this.proposta.data_primeira_parcela,
                valor_proposta: $this.proposta.valor_proposta,
                valor_alienacao: $this.proposta.alienacao,
                score: $this.proponente.score
            })
                .then(function (response) {
                    $('#valor_par').val(response.data.parcela_iof);
                    $('#valor_parcela').val(response.data.parcela_iof);
                    $this.proposta.taxa = response.data.taxa;
                    $this.proposta.parcela_sem_retorno = response.data.parcela_sem_retorno;
                    $this.proposta.valor_retorno = response.data.valor_retorno;
                    $this.proposta.aprovacao_automatica = response.data.aprovacao_automatica;
                    $this.loader = false;
                })
                .catch(function (error) {
                    $this.loader = false;
                })
        },

        alteraParcelas: function (parcelas, valor, taxa, parcela_sem_retorno) {
            $('#valor_par').val(valor);
            $('#parcelas').val(parcelas);
            this.proposta.parcelas = parcelas;
            this.proposta.taxa = taxa;
            this.proposta.parcela_sem_retorno = parcela_sem_retorno;
        },

        calcEntrada: function (valorProposta, valorFipe) {

            //                var valorProposta = valorProposta + ' ';
            //                valorProposta = valorProposta.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.');
            //
            //                var valorFipe = valorFipe + ' ';
            //                valorFipe = valorFipe.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.');

            var entrada = parseFloat(valorFipe) - parseFloat(valorProposta);

            if (entrada <= 0) {
                return '0,00';
            }

            return this.$utils.numberToReal(entrada);
        },

        getPas: function () {
            var $this = this;
            $this.$http.get('/pas')
                .then(function (response) {
                    $this.pas = response.data;
                })
        },

        save: function () {
            var $this = this;
            $this.loader = true;
            $this.$http.post('/propostas/' + $this.proposta.id, {
                proposta: $this.proposta,
                objeto: $this.objeto,
                proponente: $this.proponente
            })
                .then(function (response) {
                    $this.getProposta();
                })
                .catch(function (error) {
                    $this.loader = false;
                })
        },

        getAnexos: function () {
            var $this = this;
            $this.anexos = [];

            $this.$http.get('/propostas/' + $this.$route.params.id + '/anexos')
                .then(function (response) {
                    $this.anexos = response.data;
                })
        },

        anexar: function () {

            var $this = this;
            $this.loader = true;
            var form = document.getElementById('form_anexo');
            var formData = new FormData(form);

            $this.$http.post('/propostas/anexar/' + $this.$route.params.id, formData)
                .then(function (response) {
                    $('#arquivo').val('');
                    $('#nome_anexo').val('');
                    $this.loader = false;
                    $this.getAnexos();
                })
                .catch(function (error) {
                    $this.loader = false;
                })
        },

        excluirAnexo: function (id) {

            var $this = this;
            $this.loader = true;

            swal({
                title: "Atenção",
                text: 'Deseja realmente excluir este anexo?',
                type: "warning",
                buttons: true,
                showCancelButton: true,
                dangerMode: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            })
                .then((willDelete) => {
                    if (willDelete.value) {

                        $this.$http.delete('/propostas/anexos/' + $this.proposta.id + '/' + id)
                            .then(function () {
                                $this.getAnexos();
                                $this.loader = false;
                                swal.close();
                            })
                            .catch(function (error) {
                                $this.loader = false;
                                swal.close();
                            })
                    } else {
                        $this.loader = false;
                        swal.close();
                    }
                });
        },

        getProposta: function () {
            var $this = this;
            //console.log('Rota------>','/propostas/' + $this.$route.params.id + '/E/edit?visualizar=1');
            $this.$http.get('/propostas/' + $this.$route.params.id + '/E/edit?visualizar=1')
                .then(function (response) {
                    $this.proponente = response.data.proponente;
                    $this.proposta = response.data.proposta;
                    $this.objeto = response.data.objeto;
                    $this.parcelas = response.data.parcelas;
                    var avalistas = response.data.avalistas.data;

                    for (var a = 0; a < avalistas.length; a++) {
                        $this.avalista[a].cpfcnpj = avalistas[a].cpfcnpj;
                        $this.avalista[a].nome = avalistas[a].nome;
                    }

                    if (response.data.parcelas[0]) {
                        // $('#valor_par').val(response.data.parcela[0].parcela_iof);
                        $('#valor_par').val(response.data.parcelas[0].parcela_iof);
                    }

                    if (response.data.proposta) {
                        $('input').attr('disabled', true);
                        $('select').attr('disabled', true);
                    }

                    $this.seguro = false; // (localStorage.seguro == 'true')? true : false;
                    $this.loader = false;
                })
                .catch(function (error) {
                    return $this.$router.push({ name: 'IndexPropostas' });
                    $this.loader = false;
                })
        },

        // ativaSeguro: function () {
        //     var $this = this;
        //     if ($this.proposta.seguro) {
        //         $("#listaBeneficios p").removeClass('activeSeguro');
        //         $("#listaBeneficios p i").addClass('text-greensea');
        //         $("#listaBeneficios p i").removeClass('text-red');
        //     } else {
        //         $("#listaBeneficios p").addClass('activeSeguro');
        //         $("#listaBeneficios p i").removeClass('text-greensea');
        //         $("#listaBeneficios p i").addClass('text-red');
        //     }
        // },
    },

    updated() {
        if (this.proposta) {
            $('input').attr('disabled', true);
            $('select').attr('disabled', true);

            //this.ativaSeguro();
        }
    },

    mounted() {
        var $this = this;
        $this.getPas();
        $this.getAnexos();
        $this.getProposta();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/propostas/View.vue